module.exports = __webpack_public_path__ + "img/icon-big-mobile.c94f51b2.svg";